<lms-list
  [listId]="listId"
  [serviceProvider]="debatesService"
  (collectionUpdated)="setCollection($event)"
  [options]="listOptions"
>
  <div class="table-heading">
    <lms-list-header [listId]="listId" class="table-item" field="questionTitle" label="debates.label"></lms-list-header>
    <lms-list-header [listId]="listId" class="table-item" field="session" label="debates.seasons"></lms-list-header>
    <lms-list-header
      [listId]="listId"
      class="table-item"
      field="votes.positive"
      label="debates.votes"
    ></lms-list-header>
    <lms-list-header [listId]="listId" class="table-item" field="created_at" label="debates.opinions"></lms-list-header>
    <lms-list-header [listId]="listId" class="table-item" field="status" label="debates.statusLabel"></lms-list-header>
    <div class="table-item"></div>
  </div>
  <lms-debates-list-row *ngFor="let debate of debates" [debate]="debate"></lms-debates-list-row>
</lms-list>
